import _ from 'lodash'

export const getAllStatus = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.status
}

export const getAllFlags = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.flags
}

export const getAllScores = (state) => {
    var arr = new Array()
    if (typeof state.rawdata === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.scores === 'undefined') {
        return arr
    }
    return state.rawdata.scores
}

export const getReadUnRead = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.mark
}

export const getIsFromFileSystem = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.fromfilesystem
}

export const getDays = (state) => {
    var arr = new Array()
    if (typeof state.rawdata === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander.days === 'undefined') {
        return arr
    }
    arr.push({ text: '', value: '' })
    state.rawdata.calander.days.forEach(function(o) {
        arr.push({ text: o, value: o })
    })
    return arr
}

export const getMonths = (state) => {
    var arr = new Array()
    if (typeof state.rawdata === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander.months === 'undefined') {
        return arr
    }
    arr.push({ text: '', value: '' })
    state.rawdata.calander.months.forEach(function(o) {
        arr.push({ text: o, value: o })
    })
    return arr
}

export const getYears = (state) => {
    var arr = new Array()
    if (typeof state.rawdata === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander === 'undefined') {
        return arr
    }
    if (typeof state.rawdata.calander.years === 'undefined') {
        return arr
    }
    arr.push({ text: '', value: '' })
    state.rawdata.calander.years.forEach(function(o) {
        arr.push({ text: o, value: o })
    })
    return arr
}

export const getStates = (state) => {
    var arr = new Array()
    arr.push({text: 'States/Province', value: ''})
    state.states.forEach(function(o) {
        if (o.countryCode.length > 0) {
            arr.push({text: o.stateName, value: o.stateID})
        }
    })
    return arr
}

export const getSearchOwnBiz = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.searchownbiz
}

export const getShowEmailType = (state) => {
    if (typeof state.rawdata === 'undefined') {
        return new Array()
    }
    return state.rawdata.showemailtype
}

export const getDone = (state) => {
    return state.done
}

export const getAgeGroup = (state) => {
    var arr = new Array()
    if (state.product_raw_data === '') {
        return arr
    }
    _.forEach(state.product_raw_data.age_group, function(o) {
        arr.push({text: o.age_pname, value: o.age_pID})
    })
    return arr
}

export const getFlashTextOrgn = (state) => {
    return state.flash_text_orgn
}

export const getSpaceyOrgn = (state) => {
    return state.spacey_orgn
}

export const getSignOnIncentiveData = (state) => {
    var arr = new Array()
    if (state.product_raw_data === '') {
        return arr
    }
    _.forEach(state.product_raw_data.sign_on_incentive_type, function(o) {
        o.text = o.text_value
        o.value = o.key_id
        arr.push(o)
    })
    return arr
}

export const getSignOnAcceleratorType = (state) => {
    var arr = new Array()
    if (state.product_raw_data === '') {
        return arr
    }
    _.forEach(state.product_raw_data.sign_on_accelerator_type, function(o) {
        o.text = o.text_value
        o.value = o.id
        arr.push(o)
    })
    return arr
}

export const getEmailsItemRefs = (state) => {
    return state.emails_item_refs
}
export const getSidebar = (state) => {
    return state.sidebar
}
export const getAllowedSectors = (state) => {
    return state.allowed_sectors
}
export const getCurrentActiveModule = (state) => {
  return state.current_active_module
}
export const getUserId = (state) => {
  return state.user_id
}
export const getBigLoading = (state) => {
    return state.big_loading
  }
export const getDashboardType = (state) => {
return state.dashboardType
}
// export const getCheckboxData = (state) => {
//     return state.update_checkboxed
// }